import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import * as LaboratoryAction from '../../../redux/Laboratory/LaboratoryAction';
import Select from '../../UI/inputs/Select';
// eslint-disable-next-line no-unused-vars
import { CreatableProps } from 'react-select/creatable';

/**
 * @param {CreatableProps & {className: string,groupId: number}} props
 */
export default function FactorSelect({ className, groupId, isLab = false, ...props }) {
    const [isMounted, setIsMounted] = useState(false);
    const loadedFactors = useSelector((store) => store.laboratory.factors);
    const factors = useMemo(
        () => (groupId ? loadedFactors.filter((v) => v.group.id === groupId) : loadedFactors),
        [loadedFactors, groupId]
    );

    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();

    useEffect(() => {
        setIsMounted(true);
        return () => {
            setIsMounted(false);
        };
    }, []);
    const handleSearchForFactors = useCallback(
        (v) => {
            if (!isMounted) return;
            setLoading(true);
            dispatch(LaboratoryAction.getLaboratoryFactors({ search: v }, () => setLoading(false)));
        },
        [dispatch, isMounted]
    );

    const getLabel = useCallback((i) => {
        const name = i.name || '';
        const groupName = (i?.group?.title && ` (${i?.group?.title})`) || '';
        return `${name}${groupName}`;
    }, []);

    const getValue = useCallback((i) => i.id, []);

    return (
        <Select
            {...props}
            options={factors}
            getOptionLabel={getLabel}
            getOptionValue={getValue}
            isLoading={loading}
            onInputChange={handleSearchForFactors}
            placeholder="Select Factor"
            className={className}
            isLab={isLab}
        />
    );
}

FactorSelect.propTypes = {
    className: PropTypes.any,
    groupId: PropTypes.number,
    isLab: PropTypes.bool
};
